// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { fileSchema } from '@/file/api/types';
import { z } from 'zod';

export const getTicketFilesRequestSchema = z.object({
  key: z.string(),
});

type GetTicketFilesRequest = z.infer<typeof getTicketFilesRequestSchema>;

const dataSchema = z.array(fileSchema);

const getTicketFilesResponseSchema = z.object({
  data: dataSchema,
});

type GetTicketFilesResponse = z.infer<typeof dataSchema>;

/**
 * Get files for a ticket
 */
export async function getTicketFiles(
  request: GetTicketFilesRequest
): Promise<GetTicketFilesResponse> {
  const url = `/v1/ticket/${request.key}/file`;
  const response = await api.get(url);
  const parsed = await parseResponse(
    getTicketFilesResponseSchema,
    response.data,
    {
      schemaName: 'TicketFiles',
      endpoint: url,
    }
  );
  return parsed.data;
}
